// extracted by mini-css-extract-plugin
export default {"screen":"PushedScreen_screen__1dfnK","pushIn":"PushedScreen_pushIn__TFD-Z"};